import { render, staticRenderFns } from "./BillingRegistration.vue?vue&type=template&id=2db249a0&scoped=true&"
import script from "./BillingRegistration.vue?vue&type=script&lang=js&"
export * from "./BillingRegistration.vue?vue&type=script&lang=js&"
import style0 from "./BillingRegistration.vue?vue&type=style&index=0&id=2db249a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db249a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDialog,VForm,VSelect,VTextField})
